<template>
  <div>
    <div class="page-header-wrapper padding-rb">
      <PageHeader title="Overview">
        <el-form label-width="80px">
          <el-form-item :label="nameLabel">
            <el-select v-model="form.seId" :placeholder="selectPlaceholder" @change="getTableData">
              <el-option v-for="item in seList" :key="item.SEID" :label="item.Name" :value="item.SEID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Duration">
            <el-select v-model="form.dateRange" placeholder="Please select duration" @change="getTableData">
              <el-option v-for="item in dateRanges" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </PageHeader>
    </div>
    <div class="table-wrapper">
      <el-table :data="tableData" v-loading="tableLoading" element-loading-text="Loading..."
        header-row-class-name="table-header" row-class-name="table-row">
        <template v-for="(item, i) in columns">
          <el-table-column :key="i" :prop="item.prop" :label="item.label" :min-width="item.minWidth">
            <template slot-scope="{ row }">
              <router-link v-if="item.hash" :to="toPath(row, item)">
                {{ row[item.prop] }}
              </router-link>
              <template v-else-if="item.prop=='Type'" >
                {{row.types?row.types.map(item=>item.TypeDesc).join(','):''}}
              </template>
              <template v-else>
                {{ row[item.prop] }}
              </template>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <template v-if="false">
      <PageHeader title="My Message Board">
        <el-checkbox v-model="isActive">Active</el-checkbox>
        <el-button type="primary" icon="iconfont icon-save" @click="onSave">
          Save
        </el-button>
        <el-button plain icon="el-icon-refresh-left" @click="onReset">
          Cancel
        </el-button>
      </PageHeader>
      <TinymceEditor v-model="text" @onSave="onSave" />
    </template>
  </div>
</template>

<script>
import TinymceEditor from "../../components/tinymce-editor";
import { RoleCode } from "../../utils/role-constant";
export default {
  name: "Overview",
  components: { TinymceEditor },
  data() {
    return {
      form: {
        seId: "",
        dateRange: "1",
      },
      columns: [
        {
          prop: "Name",
          label: "SE/CE",
          minWidth: 95,
          hash: "Basic",
        },
        {
          prop: "Type",
          label: "Type",
          minWidth: 65,
        },
        {
          prop: "NoOfPush",
          label: "No. Of Push",
          minWidth: 115,
          hash: "PushedContent",
        },
        {
          prop: "NoOfHits",
          label: "No. Of Hits",
          minWidth: 105,
          hash: "PushedContent",
        },
        {
          prop: "AvgPageView",
          label: "Avg. Duration (s)",
          minWidth: 155,
        },
        {
          prop: "Interactions",
          label: "No. Of Messages",
          minWidth: 180,
          hash: "TextMessage",
        },
        {
          prop: "NoOfComments",
          label: "No. Of Paper Comments",
          minWidth: 200,
          hash: "PaperComments",
        },
        {
          prop: "NoOfFullArticleRequests",
          label: "No. Of Full Article Requests",
          minWidth: 230,
          hash: "FullArticleRequests",
        },
      ],
      seList: [],
      dateRanges: [
        {
          value: "1",
          label: "Last One Month",
        },
        {
          value: "2",
          label: "Last One Year",
        },
        {
          value: "0",
          label: "All",
        },
      ],
      tableLoading: false,
      tableData: [],
      textCache: "",
      text: "",
      isActive: false,
    };
  },
  computed: {
    nameLabel() {
      const role = this.$store.state.role;
      return role === RoleCode.ML || role === RoleCode.Supervisor
        ? "HCP"
        : (role === RoleCode.VMSL?'vCE':"Customer");
    },
    selectPlaceholder() {
      return `Please select ${this.nameLabel.toLowerCase()}`;
    },
    role() {
      return this.$store.state.role;
    },
    hasType() {
      return this.role === RoleCode.VMSL || this.role === RoleCode.Supervisor || this.role === RoleCode.ML || this.role === RoleCode.Admin;
    },
  },
  created() {
    this.columns[0].label = this.nameLabel;
    this.getSe();
    this.getTableData();
    this.getNotice();
    this.bus.$on("refresh", ({ name }) => {
      if (this.$options.name === name) {
        this.getSe();
        this.getTableData();
        this.getNotice();
      }
    });
    if(!this.hasType){
      this.columns = this.columns.filter(item=> item.prop!='Type')
    }
  },
  methods: {
    toPath(row, item) {
      // console.log( `/${this.nameLabel.toLowerCase()=='se/ce'?'se':this.nameLabel.toLowerCase()}/${row.SEID}/${row.UserID}${item.hash !== "Basic" ? `#${item.hash}` : ""
      // }`)
      return `/${this.nameLabel.toLowerCase()=='hcp'||this.nameLabel.toLowerCase()=='vce'?'se':this.nameLabel.toLowerCase()}/${row.SEID}/${row.UserID}${item.hash !== "Basic" ? `#${item.hash}` : ""
        }`;
    },
    getSe() {
      this.axios.get(`/sys/getSe`).then(({ code, data, msg }) => {
        if (200 === code) {
          this.seList = [{ Name: "All", SEID: "" }].concat(data);
        } else {
          this.$message.error(msg);
        }
      });
    },
    getTableData() {
      this.tableLoading = true;
      this.axios
        .get("/sys/overview", {
          params: this.form,
        })
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.tableData = data;
          } else {
            this.$message.error(msg);
          }
          this.tableLoading = false;
        });
    },
    getNotice() {
      this.axios.get("/sys/getNotice").then(({ code, data, msg }) => {
        if (code === 200) {
          this.textCache = data.NoticeText;
          this.text = data.NoticeText;
          this.isActive = data.Active;
        } else {
          this.$message.error(msg);
        }
      });
    },
    onSave() {
      this.axios
        .post("/sys/saveNotice", { text: this.text, isActive: this.isActive })
        .then(({ code, msg }) => {
          if (code === 200) {
            this.$message.success("Save notice successfully");
            this.textCache = this.text;
          } else {
            this.$message.error(msg);
          }
        });
    },
    onReset() {
      this.text = this.textCache;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form {
  display: flex;
}

.page-header {
  .el-checkbox {
    margin-right: 10px;
  }
}
</style>
